export default "__VITE_PUBLIC_ASSET__d1f46deb__"